export const BusinessType = {
  DISTRIBUTOR: 1,
  MANUFACTURER: 2,
  WHOLESALER: 3,
  COMMISSION_AGENT: 4,
} as const;

export type BusinessType = (typeof BusinessType)[keyof typeof BusinessType];

export const BusinessConstitution = {
  PROPRIETORSHIP: 1,
  PARTNERSHIP: 2,
  LLP: 3,
  PRIVATE_LIMITED: 4,
  PUBLIC_LIMITED: 5,
} as const;

export type BusinessConstitution = (typeof BusinessConstitution)[keyof typeof BusinessConstitution];

export const BUSINESS_TYPE_LABELS: Record<BusinessType, string> = {
  [BusinessType.DISTRIBUTOR]: 'Distributor',
  [BusinessType.MANUFACTURER]: 'Manufacturer',
  [BusinessType.WHOLESALER]: 'Wholesaler',
  [BusinessType.COMMISSION_AGENT]: 'Commission Agent',
};

export const BUSINESS_CONSTITUTION_LABELS: Record<BusinessConstitution, string> = {
  [BusinessConstitution.PROPRIETORSHIP]: 'Proprietorship',
  [BusinessConstitution.PARTNERSHIP]: 'Partnership',
  [BusinessConstitution.LLP]: 'LLP',
  [BusinessConstitution.PRIVATE_LIMITED]: 'Private Limited',
  [BusinessConstitution.PUBLIC_LIMITED]: 'Public Limited',
};

/**
 * Utility to get human readable Business Type label
 */
export const getBusinessTypeName = (type: string | number | undefined | null): string => {
  if (type === undefined || type === null || type === '') return 'N/A';
  const num = Number(type);
  if (!isNaN(num) && num in BUSINESS_TYPE_LABELS) {
    return BUSINESS_TYPE_LABELS[num as BusinessType];
  }
  return String(type);
};

/**
 * Utility to get human readable Business Constitution label
 */
export const getBusinessConstitutionName = (constitution: string | number | undefined | null): string => {
  if (constitution === undefined || constitution === null || constitution === '') return 'N/A';
  const num = Number(constitution);
  if (!isNaN(num) && num in BUSINESS_CONSTITUTION_LABELS) {
    return BUSINESS_CONSTITUTION_LABELS[num as BusinessConstitution];
  }
  return String(constitution);
};

/**
 * Utility to check if a business type is commission based
 */
export const isCommissionBasedType = (type: string | number | undefined | null): boolean => {
  if (type === undefined || type === null || type === '') return false;
  return Number(type) === BusinessType.COMMISSION_AGENT;
};
